import { OTHER_TEXT_MAX_LENGTH } from '@citizen-walk/shared-types';

/**
 * 選択肢「その他」の後ろに置く自由記入欄 (入力項目の userFields / postFields 共通、2026-10-06)。
 *
 * 保存先 (`{key}__other`) と「その他」の判定は呼び出し側が `fieldOtherText.ts` の helper で行う。
 * 本部品は見た目と入力だけを持つ:
 *   - `inline`: チェックボックス / ラジオの「□その他」の行の中に並べる (行の残り幅を使う)
 *   - それ以外: ボタン / プルダウン型の下に 1 行で置く
 * 記入し始めたら「その他」を自動で選ぶのは呼び出し側 (`onChange` で選択値も更新する)。
 */
export interface OtherTextInputProps {
  value: string;
  onChange: (value: string) => void;
  /** 読み上げ用の名前 (例: 「性別（その他の内容）」)。 */
  ariaLabel: string;
  disabled?: boolean;
  /** 必須の項目で「その他」を選んでいるのに未記入のとき true (枠を警告色にする)。 */
  invalid?: boolean;
  inline?: boolean;
  placeholder?: string;
}

export function OtherTextInput({
  value,
  onChange,
  ariaLabel,
  disabled,
  invalid,
  inline,
  placeholder = '内容を入力',
}: OtherTextInputProps) {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
      aria-invalid={invalid ? true : undefined}
      disabled={disabled}
      maxLength={OTHER_TEXT_MAX_LENGTH}
      placeholder={placeholder}
      className={`${
        inline ? 'min-w-0 flex-1 py-1.5' : 'mt-2 w-full min-h-touch'
      } rounded-md border px-3 text-sm disabled:bg-slate-100 ${
        invalid ? 'border-danger-400' : 'border-slate-300'
      }`}
    />
  );
}
